export default "__VITE_ASSET__CwJmWka5__"